import { z } from "zod";
import { isValidPhoneNumber } from "./Utils"

export const contactSchema = z.object({
  name: z.string().max(50).optional(),
  email: z.string().email().optional().nullable(),
  phoneNo: z.string().refine(isValidPhoneNumber, {message: "Invalid format"}).optional().nullable()
});

export type ContactType = z.infer<typeof contactSchema>;